export enum IdentifierFieldType {
    Subsurface = 1,
    Infrastructure = 2,
    Emissions = 4,
    CCSProject = 8,
    Blocks = 32,
    Licences = 64,
    Windfarms = 128,
    Aquifers = 256,
}

// Type 1 is Storage in the database and on the API, but subsurface is the only name for it users
// have ever been shown.
export const assetTypeLabel: Record<IdentifierFieldType, string> = {
    [IdentifierFieldType.Subsurface]: 'subsurface assets',
    [IdentifierFieldType.Infrastructure]: 'infrastructure assets',
    [IdentifierFieldType.Emissions]: 'CO2 emitters',
    [IdentifierFieldType.CCSProject]: 'CCS projects',
    [IdentifierFieldType.Blocks]: 'blocks',
    [IdentifierFieldType.Licences]: 'licences',
    [IdentifierFieldType.Windfarms]: 'windfarms',
    [IdentifierFieldType.Aquifers]: 'aquifers',
};

export type ImputationModelSummary = {
    id: string;
    priority: number;
    r2?: number;
    isEnabled: boolean;
}

export type ImputationParameter = {
    tagAttributeId: string;
    key: string;
    name: string;
    // The asset type the parameter belongs to, which is also the set candidateCount is taken over.
    identifierFieldType: IdentifierFieldType;
    models: ImputationModelSummary[];
}

export type ImputationModelsResponse = {
    parameters: ImputationParameter[];
}

export type ImputationModelCount = {
    priority: number;
    // Fields this model fills once every model above it has been tried, so the counts partition the
    // candidates rather than overlapping.
    infilledCount: number;
}

export type ImputationModelCounts = {
    tagAttributeId: string;
    candidateCount: number;
    models: ImputationModelCount[];
}
